import { decodeToken } from './auth';

export const userPermission = () => {
  const decoded = decodeToken('da');
  if (!decoded) return null;

  const role = decoded?.roles;

  const subRoles = ['SubAdmin', 'Cashier', 'Operation', 'Developer'];

  const isSubUser = subRoles.includes(role);

  return isSubUser ? decoded?.merchantId : decoded?.id;
};

export const emailPermission = () => {
  const decoded = decodeToken('da');
  if (!decoded) return null;

  const role = decoded?.roles;

  const subRoles = ['SubAdmin', 'Cashier', 'Operation', 'Developer'];

  const isSubUser = subRoles.includes(role);

  return isSubUser ? decoded?.merchantEmail : decoded?.email;
};